var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanProductBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_2065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 8.5H11V16.5H21V8.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5H23L27 3.5V6.5L23 4.5H11V1.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.5H14V8.5H18V4.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5C21 16.5 31 19.5 31 30.5C31 38.867 28.686 53.6 27.578 60.172C27.4205 61.1036 26.9377 61.9492 26.2156 62.5585C25.4935 63.1678 24.5788 63.5014 23.634 63.5H8.366C7.42118 63.5014 6.50645 63.1678 5.78435 62.5585C5.06226 61.9492 4.57955 61.1036 4.422 60.172C3.314 53.6 1 38.867 1 30.5C1 19.5 11 16.5 11 16.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 30.5H31",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 30.5H25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 30.5H21",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 44.5H2",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 16.5H44V24.5H54V16.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 12.5H46V16.5H52V12.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 24.5C44 24.5 35 29.5 35 43.5V54.5C35 56.8869 35.9482 59.1761 37.636 60.864C39.3239 62.5518 41.6131 63.5 44 63.5H54C56.3869 63.5 58.6761 62.5518 60.364 60.864C62.0518 59.1761 63 56.8869 63 54.5V43.5C63 29.5 54 24.5 54 24.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 9.5H55L59 11.5V14.5L55 12.5H43V9.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 34.457C47.636 34.4857 48.3027 34.5 49 34.5C57 34.5 61 32.5 61 32.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 34.0859C43.619 34.1759 44.286 34.2569 45 34.3229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 32.5C38.2816 33.0624 39.6238 33.4751 41 33.73",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 50.5C35 50.5 39.667 52.5 49 52.5C58.333 52.5 63 50.5 63 50.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.679 22.5C24.1948 22.0537 23.623 21.7131 23 21.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0004 26.5C26.6985 25.4253 26.2141 24.4106 25.5684 23.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_2065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanProductBlack);
export default __webpack_public_path__ + "static/media/clean-product-black.42326a2b479747059c574e4f1119fa52.svg";
export { ForwardRef as ReactComponent };